import React, { useState, useMemo } from 'react';
import styled from 'styled-components/macro';

import BoxInputs, { Wrapper as _BoxInput } from '../../common/components/BoxInputs';
import useMasterTimeline from '../useMasterTimeline';

const Wrapper = styled.div`
  text-align: center;

  ${_BoxInput} {
    margin: 20rem 0;
  }
`;

const PromptYear = styled.p`
  color: white;
  font-size: 22rem;

  letter-spacing: 0.5rem;
`;

const Responsible = styled.p`
  color: white;
  font-size: 16rem;
  white-space: pre;
`;

const Button = styled.button`
  margin: 20rem 0;
  padding: 10rem 20rem;
  background: #f9ecc2;

  color: #006e41;
  font-size: 18rem;
  cursor: pointer;

  border-radius: 8rem;
  border: 2rem solid #fff0;
  outline: none;

  transition: 0.25s background, 0.25s opacity;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    cursor: auto;
    background: #f9ecc266;
  }
`;

const Birthday = ({ onContinue }: { onContinue: () => void }) => {
  const currentYear = useMemo(() => (new Date()).getFullYear(), []);
  const [buttonAllow, setButtonAllow] = useState(false);

  const handleComplete = (year: string) => {
    const difference = currentYear - Number(year);

    difference >= 18 ?
      setButtonAllow(true) :
      setButtonAllow(false);
  }

  return (
    <Wrapper>
      <PromptYear>
        Enter your birthday year
      </PromptYear>

      <BoxInputs
        number={4}
        type="numeric"
        onComplete={handleComplete}
        onIncomplete={() => setButtonAllow(false)}
      />

      <Responsible>
        {`You have to be at least 18 years old to visit this site.\nCheers responsibly!`}
      </Responsible>

      <Button
        onClick={onContinue}
        disabled={!buttonAllow}
      >
        Continue
      </Button>
    </Wrapper>
  );
}

export default Birthday;